import React from 'react';
import { Box, Popover, Tooltip } from '@mui/material';
import { ReportsModel } from '../../models/reports.model';
import { CampaignHistoryReport, CampaignHistoryMsgReportIcon } from '../../icon';
import { useNavigate } from 'react-router';
import { AppRoutes } from '../routes/route.path';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors'

interface MessageReportPopoverProps {
    open: boolean;
    onClose: () => void;
    anchorEl: HTMLButtonElement | null;
    loadingReports: boolean;
    campaignMessageReport?: ReportsModel;
    IsMobileDevice: boolean
}

const MessageReportPopover: React.FC<MessageReportPopoverProps> = ({ open, onClose, anchorEl, loadingReports, campaignMessageReport, IsMobileDevice }) => {
    const navigate = useNavigate();
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            classes={{ paper: `${IsMobileDevice ? "w-p-10 p-2 bg-color-primary-btn-focus  opacity-3-5 w-p-60 h-p-13" : " o-y-hidden w-p-10 p-2 bg-color-primary-btn-focus  opacity-3-5 w-p-20 h-p-12"} ${IsDarkMode ? "" : "color-secondary"}` }}
        >
            {loadingReports ? (
                <Box className='d-flex align-center justify-center w-p-100 h-p-100'>
                    <Box>Loading...</Box>
                </Box>
            ) : campaignMessageReport && campaignMessageReport.AuditCompleted ? (
                <div>
                    <Box className='d-flex justify-between'>
                        <Box className='h4-regular'>Message stats</Box>
                        <Tooltip title='Click on this icon to go to reports' placement='bottom'>
                            <Box className="c-pointer" onClick={() => navigate(AppRoutes.REPORTS, { state: { auditData: campaignMessageReport } })}>
                                <CampaignHistoryReport />
                            </Box>
                        </Tooltip>
                    </Box>
                    <Box className='d-flex justify-between h5-regular align-items-center mt-3'>
                        <Box className='d-flex flex-direction justify-center align-center border-right-4 w-p-33'>
                            <Box className='h2-regular'>{campaignMessageReport.DeliveredContacts?.length}</Box>
                            <Box>Delivered</Box>
                        </Box>
                        <Box className='d-flex flex-direction justify-center border-right-4 align-center w-p-33'>
                            <Box className='h2-regular'>{campaignMessageReport.SkippedContacts?.length}</Box>
                            <Box>Not Sent</Box>
                        </Box>
                        <Box className='d-flex flex-direction justify-center align-center w-p-33'>
                            <Box className='h2-regular'>{campaignMessageReport.BouncedContacts?.length}</Box>
                            <Box>Failed</Box>
                        </Box>
                    </Box>
                </div>
            ) : (
                <Box className='d-flex flex-direction align-center justify-center w-p-100 h-p-100'>
                    <CampaignHistoryMsgReportIcon className='mb-1' />
                    <Box className='h5-semibold'>No reports have yet been generated.</Box>
                    <Box className='h6-regular'>Upon completion, we'll let you know.</Box>
                </Box>
            )}
        </Popover>
    );
};

export default MessageReportPopover;
